import { Divider, InputNumber, Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import { pay, updatePayment } from "store/slices/paymentsSlice";
import { getStudentById } from "store/slices/studentsSlice";

const PayModal = () => {
  const dispatch = useDispatch();
  const [newPayment, setNewPayment] = useState();

  const {
    isModalOpen,
    modalType,
    modalProps: { payment, idStudent },
  } = useSelector((state) => state?.modals);

  const { loading } = useSelector((state) => state?.payments);

  const open = isModalOpen && modalType === "edit_student_payment";

  const handleChange = (value) => {
    console?.log("Input captured", value);
    setNewPayment(value);
  };

  const handleSubmit = async () => {
    try {
      const maxAmount =
        payment?.price?.[payment?.payment?.currency?.toLowerCase()];
      if (
        newPayment >
        payment?.price?.[payment?.payment?.currency?.toLowerCase()] -
          payment?.payment?.amount
      ) {
        notification?.error({
          message: `Amount cannot exceed ${maxAmount} ${payment?.payment?.currency}`,
        });
        return;
      }
      await dispatch(
        pay({
          paymentId: payment?._id,
          newPayment: {
            amount: newPayment,
          },
        })
      )?.unwrap();
      notification?.success({
        message: "Payment successful",
      });
      dispatch(getStudentById(idStudent));
      dispatch(closeModal());
    } catch (error) {
      notification?.success({
        message: error || "Error",
      });
    }
  };
  useEffect(() => {
    setNewPayment(
      payment?.price?.[payment?.payment?.currency?.toLowerCase()] -
        payment?.payment?.amount
    );
  }, [payment]);
  return (
    <Modal
      title="Make a Payment"
      centered
      open={open}
      onCancel={() => {
        dispatch(closeModal());
      }}
      onOk={() => {
        handleSubmit();
      }}
      confirmLoading={loading}
    >
      <Divider />
      <div style={{ marginBlock: "2rem", marginInline: "1rem" }}>
        <label
          htmlFor="price"
          style={{
            marginRight: "1rem",
            fontWeight: "bold",
          }}
        >
          Payed Price:
        </label>
        <InputNumber
          id="price"
          name="price"
          style={{ width: "10rem" }}
          min={1}
          type="number"
          max={
            payment?.price?.[payment?.payment?.currency?.toLowerCase()] -
            payment?.payment?.amount
          }
          value={newPayment}
          onInput={(val) => {
            console?.log("Input captured", val);
            setNewPayment(Number(val));
          }}
          status={
            newPayment >
            payment?.price?.[payment?.payment?.currency?.toLowerCase()] -
              payment?.payment?.amount
              ? "error"
              : ""
          }
        />{" "}
        {payment?.payment?.currency?.toUpperCase()}
        {newPayment >
          payment?.price?.[payment?.payment?.currency?.toLowerCase()] -
            payment?.payment?.amount && (
          <div style={{ color: "red", marginTop: "8px" }}>
            Amount cannot exceed{" "}
            {payment?.price?.[payment?.payment?.currency?.toLowerCase()] -
              payment?.payment?.amount}{" "}
            {payment?.payment?.currency?.toUpperCase()}
          </div>
        )}
      </div>
      <Divider />
    </Modal>
  );
};

export default PayModal;
